export default {
  init() {
    // JavaScript to be fired on the daily graphs page
    // buttons
    $('#butPrint').click(function() {
      window.print(); 
    });

    // buttons
    $('#butPrint').click(function() {
      window.print(); 
    });

    function getParameterByName(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // make global, since webpack uses enclosures to scope partials
    window.mhpa = window.mhpa || {};
    window.mhpa.loadAccountData = function(account) {

      // date and account comes from the url
      var dateIn = getParameterByName('date');
      var account = getParameterByName('account');
      $('#accountStatic').text(account);
      //console.log(dateIn + ' ' + account);

      // Checks if NM user //
      $.ajax({
        url: '/rrtpbillcompare/Servlet?type=is-netmeter&account=' + $('#account').val(),
        success: function(data) {
         if (data == 'rider1' || data == 'rider19') { // user is net-metering participant (1) || or NM + community generation (19)
            document.getElementById('net-grid-consumption-chart').style.display = 'block';
            document.getElementById('kWh-to-grid-chart').style.display = 'block';
            document.getElementById('kWh-from-grid-chart').style.display = 'block';
            document.getElementById('electricity-usage-chart').style.display = 'none';
            document.getElementById('average-electricity-charges-chart').style.display = 'none';
          } else if (data == 'rider5'){
            document.getElementById('kWh-from-grid-chart').style.display = 'block';
            document.getElementById('kWh-to-grid-chart').style.display = 'block';
            document.getElementById('electricity-usage-chart').style.display = 'none';
            document.getElementById('average-electricity-charges-chart').style.display = 'none'; 
          } else if (data == 'rider9'){ // user is standard && community generation (9)
            document.getElementById('average-electricity-charges-chart').style.display = 'none';
            document.getElementById('net-grid-consumption-chart').style.display = 'none';
            document.getElementById('kWh-to-grid-chart').style.display = 'none';	
          } else { // regular user
            document.getElementById('net-grid-consumption-chart').style.display = 'none';
            document.getElementById('kWh-to-grid-chart').style.display = 'none';
            document.getElementById('kWh-from-grid-chart').style.display = 'none';
            document.getElementById('electricity-usage-chart').style.display = 'block';
            document.getElementById('total-electricity-charges-chart').style.display = 'block';
            document.getElementById('average-electricity-charges-chart').style.display = 'block';
          }
        },
        cache: false,
        async: false,
      });

      // net-consumption-chart  ==> net-grid-consumption-chart //
      $.getJSON('/rrtpbillcompare/Servlet?type=net-grid-consumption-chart-daily&account=' + account + '&date=' + dateIn, function(json) {
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.xAxisCategories = json.xAxisCategories.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"').replace(', ]', ']');
        $('#spinner-net-grid-consumption-chart').hide();
        Highcharts.chart('net-grid-consumption-chart', {
          chart: {
            type: 'column',
            height: 230,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            categories: JSON.parse(json.xAxisCategories),
            labels: {
              rotation: -90,
              style: {
                fontSize: '9px',
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-hourly?account=' + account + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            showInLegend: false,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }],
        });
      });

      // local-consumption-chart  ==>  kWh-to-grid-chart //
      $.getJSON('/rrtpbillcompare/Servlet?type=kWh-to-grid-chart-daily&account=' + account + '&date=' + dateIn, function(json) {
        //console.log(json);
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.xAxisCategories = json.xAxisCategories.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"').replace(', ]', ']');
        $('#spinner-kWh-to-grid-chart').hide();
        Highcharts.chart('kWh-to-grid-chart', {
          chart: {
            type: 'column',
            height: 230,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            categories: JSON.parse(json.xAxisCategories),
            labels: {
              rotation: -90,
              style: {
                fontSize: '9px',
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-hourly?account=' + account + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            showInLegend: false,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }],
        });
      });

      // nm-CONSUMPTION-CHART ==>  kWh-from-grid-chart //
      $.getJSON('/rrtpbillcompare/Servlet?type=kWh-from-grid-chart-daily&account=' + account + '&date=' + dateIn, function(json) {
        //console.log(json);
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.xAxisCategories = json.xAxisCategories.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"').replace(', ]', ']');
        //console.log(json);
        $('#spinner-kWh-from-grid-chart').hide();
        Highcharts.chart('kWh-from-grid-chart', {
          chart: {
            type: 'column',
            description: 'Average electricity charges broken down by month for three years in cents per kilowatt hour.',
            height: 230, // Responsive Solution: Remove Width. 2019-02-20//
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            categories: JSON.parse(json.xAxisCategories),
            labels: {
              rotation: -90,
              style: {
                fontSize: '9px',
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-hourly?account=' + account + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            showInLegend: false,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }],
        });
      });

      //Standard Users//
      // CONSUMPTION-CHART ==>  electricity-usage-chart//
      $.getJSON('/rrtpbillcompare/Servlet?type=electricity-usage-chart-daily&account=' + account + '&date=' + dateIn, function(json) {
        //console.log('electricity-usage-chart :: ');
        //console.log(json);
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.xAxisCategories = json.xAxisCategories.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"').replace(', ]', ']');
        $('#spinner-electricity-usage-chart').hide();
        Highcharts.chart('electricity-usage-chart', {
          chart: {
            type: 'column',
            height: 230,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            categories: JSON.parse(json.xAxisCategories),
            labels: {
              rotation: -90,
              style: {
                fontSize: '9px',
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-hourly?account=' + account + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            showInLegend: false,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }],
        });
      });

      // total-electricity-charges-chart //
      $.getJSON('/rrtpbillcompare/Servlet?type=total-electricity-charges-chart-daily&account=' + account + '&date=' + dateIn, function(json) {
        //console.log('total-electricity-charges-chart ::');
        //console.log(json);
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.xAxisCategories = json.xAxisCategories.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"').replace(', ]', ']');
        $('#spinner-total-electricity-charges-chart').hide();
        Highcharts.chart('total-electricity-charges-chart', {
          chart: {
            type: 'column',
            height: 230,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            categories: JSON.parse(json.xAxisCategories),
            labels: {
              rotation: -90,
              style: {
                fontSize: '9px',
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '${point.y:.2f}',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-hourly?account=' + account + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            showInLegend: false,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }],
        });
      });
      
      // average-electricity-charges-chart //
      $.getJSON('/rrtpbillcompare/Servlet?type=average-electricity-charges-chart-daily&account=' + account + '&date=' + dateIn, function(json) {
        //console.log('average-electricity-charges-chart-daily :: ');
        //console.log(json);
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.xAxisCategories = json.xAxisCategories.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"').replace(', ]', ']');
        $('#spinner-average-electricity-charges-chart').hide();
        Highcharts.chart('average-electricity-charges-chart', {
          chart: {
            type: 'column',
            height: 230,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            categories: JSON.parse(json.xAxisCategories),
            labels: {
              rotation: -90,
              style: {
                fontSize: '9px',
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f}¢',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-hourly?account=' + account + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            showInLegend: false,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }],
        });
      });
    }

    mhpa.loadAccountData(getParameterByName('account'));

  },
  finalize() {
    // JavaScript to be fired on the daily graphs page, after the init JS
  },
};
